export default __webpack_public_path__ + "static/media/1COVER-Cloudxier-CSR-Report-Pertamina.75788e3f.jpg";